import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { FaPencilAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { notFound } from "../../../enums/mainEnums";
import AvatarImg from "../../../Assets/images/icons/user.png";
import jsPDF from "jspdf";
import "jspdf-autotable";

const DataTable = ({ data, setSelectedEmployeeId, handleShow }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  // Handle sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export to PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("Employees Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [["ID", "Name", "Role", "Active"]],
      body: sortedData.map((item) => [
        item.id || "N/A",
        item.name || "N/A",
        item.role || "N/A",
        item.active ? "Active" : "Not Active",
      ]),
    });
    doc.save("employeesTable.pdf");
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", key: "id" },
                { label: "Photo", key: null },
                { label: "Name", key: "name" },
                { label: "Role", key: "role" },
                { label: "Active", key: "active" },
                { label: "Actions", key: null },
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={column.key ? () => handleSort(column.key) : undefined}
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row" align="center">
                  {item?.id}
                </TableCell>
                <TableCell align="center">
                  <div className="flex items-center justify-center w-full">
                    <div className="image-container w-11 h-11 rounded-full overflow-hidden">
                      <img
                        src={item?.photo !== notFound ? item?.photo : AvatarImg}
                        className="w-full h-full object-cover"
                        alt={item?.name}
                      />
                    </div>
                  </div>
                </TableCell>
                <TableCell align="center">{item?.name}</TableCell>
                <TableCell align="center">{item?.role}</TableCell>
                <TableCell align="center">
                  <span
                    className={`badge w-24 text-darkTextColor ${item?.active ? "bg-[#28a745]" : "bg-[#ff6877]"
                      }`}
                  >
                    {item?.active ? "Active" : "Not active"}
                  </span>
                </TableCell>
                <TableCell align="center">
                  <div className="flex gap-x-10 text-lg items-center justify-center">
                    <Link
                      to={`/Employees/Edit/${item?.id}`}
                      color="inherit"
                      underline="none"
                    >
                      <FaPencilAlt className="text-[#6c757d]" />
                    </Link>
                    {/* <FaTrashAlt
                      onClick={() => {
                        setSelectedEmployeeId(item?.id);
                        handleShow();
                      }}
                      className="text-[#d9534f] cursor-pointer"
                    /> */}
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
